import {ServiceOrderWorkDeliveryProps} from "..";
import {StyledServiceOrderListHeaderTitle} from "../../../../../header/styles";
import {StyledServiceOrderWorkDeliveryHeader} from "../styles";
import {ServiceOrderDeliverWorkButton} from "./deliver-work-button";

export type ServiceOrderWorkDeliveryHeaderProps = {
  status: ServiceOrderWorkDeliveryProps["status"];
  hasMaxedOutDelivery: boolean;
};

export function ServiceOrderWorkDeliveryHeader({
  status,
  hasMaxedOutDelivery,
}: ServiceOrderWorkDeliveryHeaderProps) {
  return (
    <StyledServiceOrderWorkDeliveryHeader>
      <StyledServiceOrderListHeaderTitle>Work delivery</StyledServiceOrderListHeaderTitle>
      <ServiceOrderDeliverWorkButton
        hasMaxedOutDelivery={hasMaxedOutDelivery}
        status={status}
      />
    </StyledServiceOrderWorkDeliveryHeader>
  );
}
